import React from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Form, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const ServiceBooked = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const formSubmit = (data) => {
        console.log(data);
        toast('Thank you for the booking.');
        // toast(`${JSON.stringify(data)}`);
        // alert(`${JSON.stringify(data)}`);
    }
    // console.log(errors);

    const { serviceBookedId } = useParams();
    return (
        <div className='py-5'>
            <div className='p-5 d-flex flex-column align-items-center justify-content-center'>
                <h2 className='mb-4 text-success'>Book the {serviceBookedId}<sup>th</sup> Service</h2>
                <Form onSubmit={handleSubmit(formSubmit)} className='form-container'>
                    <Form.Group className="mb-3 " controlId="formBasicName">
                        <Form.Control
                            type="text"
                            name="name"
                            placeholder="Name"
                            {...register("name", { required: "User name is required" })}
                        />
                    </Form.Group>
                    <p className='text-danger'>{errors.name?.message}</p>

                    <Form.Group className="mb-3 " controlId="formBasicEmail">
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="Email"
                            {...register("email", {
                                required: "User email is required",
                                pattern: {
                                    value: /^\S+@\S+\.\S+$/i,
                                    message: "This is not a valid email"
                                }
                            })}
                        />
                    </Form.Group>
                    <p className='text-danger'>{errors.email?.message}</p>

                    <Form.Group className="mb-3" controlId="formBasicPhone">
                        <Form.Control
                            type="phone"
                            name="phone"
                            placeholder="Phone"
                            {...register("phone", {
                                required: "User phone number is required",
                                minLength: {
                                    value: 11,
                                    message: "Phone must be equal to 11 character long"
                                },
                                maxLength: {
                                    value: 11,
                                    message: "Phone must be equal to 11 character long"
                                }
                            })}
                        />
                    </Form.Group>
                    <p className='text-danger'>{errors.phone?.message}</p>

                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            placeholder="Address"
                            {...register("address", {
                                required: "User address is required"
                            })}
                        />
                    </Form.Group>
                    <p className='text-danger'>{errors.address?.message}</p>

                    <Button variant="outline-success" type="submit" className='w-100'>
                        Submit
                    </Button>
                </Form>
                <ToastContainer></ToastContainer>
            </div>
        </div>
    );
};

export default ServiceBooked;